let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dw4di")).then(() => parcelRequire('PDgcp'));